module.exports = vendor_1f2fb66734d9536b466e;